import { BaseDropdown } from 'src/components/BaseDropdown';
import { BaseErrorMessage } from 'src/components/BaseErrorMessage';
import { BaseInput } from 'src/components/BaseInput';
import React from 'react';
import { TBaseSelectProps } from './BaseSelect.types';
import classnames from 'classnames';
import { openModal } from 'src/redux/modals/modals.slice';
import s from './BaseSelect.module.scss';
import { selectIsModalOpened } from 'src/redux/modals/modals.selectors';
import { useAppDispatch } from 'src/redux/store';
import { useModal } from 'src/hooks/useModal';
import { useSelector } from 'react-redux';

export const BaseSelect: React.FC<TBaseSelectProps> = function BaseSelect({
  className,
  name,
  value,
  label,
  options,
  disabled,
  error,
  onChange,
  theme,
}) {
  const { id: modalId } = useModal();
  const selectedLabel = (options.find((o) => o.value === value) || {}).label;
  const dropdownIsOpen = useSelector(selectIsModalOpened(modalId));
  const dispatch = useAppDispatch();

  const handleSelect = (newValue: TBaseSelectProps['value']) => {
    // value === newValue - this condition is required to make siblingFieldsReactions work properly.
    if (disabled || value === newValue) return;
    onChange?.({ name, value: newValue });
  };

  return (
    <div
      className={classnames(className, s.container, {
        [s.disabled]: disabled,
        [s.opened]: dropdownIsOpen,
      })}>
      <BaseInput
        className={s.input}
        type="text"
        value={selectedLabel ? String(selectedLabel) : ''}
        theme={theme}
        name={name}
        iconRight="arrow"
        iconRightSize={8}
        label={label}
        onClick={() => {
          if (disabled) return;
          if (dropdownIsOpen) return;
          dispatch(openModal(modalId));
        }}
        showValidationIcon={false}
      />

      <BaseDropdown options={options} onSelect={handleSelect} modalId={modalId} position="bottom" />

      <BaseErrorMessage>{error}</BaseErrorMessage>
    </div>
  );
};
